<div class="container-fluid section p-3">
    <div class="d-flex flex-row justify-content-between mb-2">
        <div>
            <span class="header mr-4 ml-1">My notes</span>
            <button class="btn btn-theme" data-toggle="modal" data-target="#create-note">
                <img src="../../../../../../assets/Images/add_circle.svg"><span class="add-label ml-2">Add new</span>
            </button>
        </div>
        <div [routerLink]="['/notes-list']" *ngIf="notes.length && notes.length==3">
            <span class="navigate-text mr-2">VIEW ALL</span>
            <i class="fas fa-long-arrow-alt-right arrow-icon mr-1"></i>
        </div>
    </div>
    <div class="row" *ngIf="notes.length">
        <div class="col-md-4 py-2 py-md-2 px-md-2" *ngFor="let note of notes">
            <div class="sub-section p-2">
                <span class="title">{{note?.noteTitle}}</span>
                <div class="note-sub-title-section">
                    <span class="sub-title mt-1">{{note?.noteText}}</span>
                </div>
                <div class="horizontal-line my-2"></div>
                <span class="note-time">{{note?.createdAt | date:'MMM dd EEE, hh:mm a'}}</span>
            </div>
        </div>
    </div>
    <div class="no-data" *ngIf="!notes.length">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Notes">
        <span>No notes</span>
    </div>
</div>

<app-create-note (note)="updateNotes($event)"></app-create-note>